:host {
    display: block;
}

.rating-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1600px;

    ::slotted(lilu-heading) {
        text-align: center;
        margin-bottom: 16px;

        @include breakpointMin("md") {
            margin-bottom: 35px;
        }
    }

    lilu-hr {
        margin-bottom: 16px;

        @include breakpointMin("md") {
            margin-bottom: 68px;
        }
    }

    .rating-overview {
        display: grid;
        grid-template-columns: 1fr;
        row-gap: 20px;
        margin-bottom: 35px;

        @include breakpointMin("md") {
            grid-template-columns: repeat(12, 1fr);
            margin-bottom: 126px;
        }

        .rating-details {


            @include breakpointMin("md") {
                grid-column: 4 / span 3;
                grid-row: 1;
            }

            .average {
                font-family: var(--primary-font);
                margin-bottom: 25px;

                .average-icon {
                    font-weight: var(--font-weight-regular);
                    font-size: 18px;
                    line-height: 27px;
                    margin-right: 19px;
                }

                .average-number {
                    font-weight: var(--font-weight-bold);
                    font-size: 50px;
                    line-height: 64px;
                }
            }

            lilu-rating {
                margin-bottom: 43px;
            }

            .rating-comment-link {
                margin-bottom: 25px;
            }
        }

        .rating-list {
            display: flex;
            flex-direction: column;
            row-gap: 16px;

            @include breakpointMin("md") {
                grid-column: 8 / span 5;
                grid-row: 1;
                margin-top: 20px;
            }

            .rating-list-item {
                display: flex;
                align-items: center;
                gap: 18px;

                @include breakpointMin("md") {
                   gap: 39px;
                }
            }
        }

    }

    ::slotted(lilu-comment) {
        margin-bottom: 20px;
    }

    ::slotted(lilu-comment:last-of-type) {
        margin-bottom: 0;
    }

    ::slotted([slot="load-more"]) {
        margin-top: 30px;
    }
}
